module.exports = __webpack_public_path__ + "img/압구정 미용실.fed2513b.png";